.FilterTabs {
  -webkit-user-select: none;
  user-select: none;
  cursor: pointer;
  border-radius: var(--radius-sm);

  &[data-open="false"] button[role="tab"] {
    border-radius: var(--radius-sm);
    padding-bottom: var(--space-sm);

    &::before,
    &::after {
      display: none;
    }
  }
}

.FilterTabsPanel[data-active="true"] {
  display: grid;
  gap: var(--space-xs);
}

.FilterTabsPanels {
  display: none;

  &[data-open="true"] {
    display: block;
  }
}

.FilterTabsSummary {
  position: relative;
  display: grid;
  grid: auto / 1fr max-content;
  place-content: center;
  gap: var(--space-sm);
  font-size: 0.9375rem;
  font-weight: 600;

  .ToggleButton {
    cursor: pointer;
    border: none;
    background: transparent;
    width: 100%;
    justify-content: flex-end;
    display: inline-flex;
    padding: 0 var(--space-lg);
    height: 34px;
    border-radius: var(--radius-sm);
  }

  svg {
    color: var(--neutral);
    place-self: center;
  }
}
